<template>
  <Dialog
    :visible="visible"
    modal
    :header="$t('editor_ziggu.actions.link')"
    :baseZIndex="100"
    @update:visible="$emit('close')"
    class="w-120"
    appendTo="body"
  >
    <form
      class="flex w-full flex-col gap-4"
      @submit.prevent="submit"
    >
      <div class="flex w-full flex-col gap-2">
        <div
          v-if="selectedText"
          class="flex flex-col gap-1"
        >
          <span class="text-sm font-medium text-gray-700">{{ $t('editor_ziggu.labels.link_text') }}:</span>
          <div class="rounded border border-gray-200 bg-gray-50 p-2 text-sm text-gray-600">
            "{{ $truncate(selectedText, 50) }}"
          </div>
        </div>
        <InputText
          id="link-input"
          v-model="url"
          :placeholder="$t('editor_ziggu.placeholders.link')"
          type="text"
          class="p-inputtext-sm"
          autofocus
          @keydown.esc.prevent="$emit('close')"
        />
      </div>
      <div class="flex w-full justify-center gap-2">
        <ButtonSecondary
          type="button"
          class="flex-1"
          @click="$emit('close')"
        >
          {{ $t('editor_ziggu.actions.cancel') }}
        </ButtonSecondary>
        <ButtonPrimary
          type="submit"
          class="flex-1"
        >
          {{ $t('editor_ziggu.actions.apply') }}
        </ButtonPrimary>
      </div>
    </form>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';

export default {
  name: 'LinkModal',
  components: {
    Dialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    initialUrl: {
      type: String,
      default: '',
    },
    selectedText: {
      type: String,
      default: '',
    },
  },
  emits: ['close', 'submit'],
  data() {
    return {
      url: this.initialUrl,
    };
  },
  watch: {
    initialUrl(newUrl) {
      this.url = newUrl;
    },
    visible(newValue) {
      if (newValue) {
        this.url = this.initialUrl;
      }
    },
  },
  methods: {
    submit() {
      this.$emit('submit', this.url);
    },
  },
};
</script>
